var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-comparison" }, [
    _c("div", { staticClass: "c-comparison__header" }, [
      _c("div", { staticClass: "c-comparison-header" }, [
        _c("div", { staticClass: "c-comparison-header__title" }, [
          _c("h1", { staticClass: "c-title" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.$t("Comparison.Page.title")) +
                "\n                "
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.isInitialized && _vm.items.length
          ? _c("div", { staticClass: "c-comparison-header__actions" }, [
              _c(
                "button",
                {
                  staticClass: "c-btn is-share",
                  attrs: { type: "button" },
                  on: { click: _vm.share },
                },
                [
                  _c("i", {
                    staticClass: "ico ico-share",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("Comparison.Page.share")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "c-btn is-delete",
                  attrs: { type: "button" },
                  on: { click: _vm.removeAll },
                },
                [
                  _c("i", {
                    staticClass: "ico ico-delete",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("Comparison.Page.deleteAll")) +
                      "\n                "
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.isInitialized && _vm.items.length && Object.keys(_vm.types).length > 1
      ? _c(
          "div",
          { staticClass: "c-comparison__navigation" },
          _vm._l(_vm.types, function (type, index) {
            return _c(
              "button",
              {
                key: index,
                staticClass: "c-btn",
                class: { "is-active": _vm.activeGroup == type.id },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.changeType(type.id)
                  },
                },
              },
              [
                _vm._v("\n            " + _vm._s(type.name) + " "),
                _c("span", { staticClass: "c-badge" }, [
                  _vm._v(_vm._s(type.count)),
                ]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "c-comparison__table" }, [
      _vm.isInitialized && !_vm.items.length
        ? _c("div", { staticClass: "c-msg c-msg--info is-flash" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("Comparison.Table.empty")) +
                "\n        "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isInitialized && _vm.items.length
        ? _c("div", { staticClass: "c-comparison-table js-comparison-table" }, [
            _c(
              "div",
              {
                staticClass:
                  "c-comparison-table__header syncscroll js-comparison-table-header",
                class: { "is-sticky": _vm.isSticky },
                attrs: { name: "comparison-table" },
              },
              [
                _c(
                  "div",
                  { staticClass: "c-comparison-table__column is-aside" },
                  [
                    _c("div", { staticClass: "c-comparison-group__item" }, [
                      _c("span", { staticClass: "is-key" }, [
                        _vm._v(_vm._s(_vm.$t("Comparison.Table.product"))),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.filteredItems, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "c-comparison-table__column" },
                    [
                      _c("ComparisonProduct", {
                        attrs: { item: item },
                        on: { remove: _vm.removeItem },
                      }),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "c-comparison-table__content syncscroll",
                attrs: { name: "comparison-table" },
              },
              [
                _c(
                  "div",
                  { staticClass: "c-comparison-table__column is-aside" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._l(_vm.filteredProperties, function (group, groupId) {
                      return _c("ComparisonGroup", {
                        key: groupId,
                        attrs: { group: group, groupId: groupId },
                      })
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._l(_vm.filteredItems, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "c-comparison-table__column" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "c-comparison-group__item js-comparison-group-item",
                        },
                        [
                          _c("span", { staticClass: "is-key" }, [
                            _vm._v(
                              "\n                            Hodnotenie\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "is-value" }, [
                            _c("div", { staticClass: "c-rating" }, [
                              _c("div", { staticClass: "c-rating__stars" }, [
                                _c("div", { staticClass: "c-stars" }, [
                                  _c(
                                    "div",
                                    { staticClass: "c-stars__empty" },
                                    _vm._l(5, function (n) {
                                      return _c("i", {
                                        key: n,
                                        staticClass: "ico ico-star",
                                        attrs: { "aria-hidden": "true" },
                                      })
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "c-stars__full",
                                      style: {
                                        width: `${item.rating_avg || 0}%`,
                                      },
                                    },
                                    _vm._l(5, function (n) {
                                      return _c("i", {
                                        key: n,
                                        staticClass: "ico ico-star",
                                        attrs: { "aria-hidden": "true" },
                                      })
                                    }),
                                    0
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              item.rating_sum
                                ? _c(
                                    "div",
                                    { staticClass: "c-rating__count" },
                                    [
                                      _vm._v(
                                        "\n                                    (" +
                                          _vm._s(item.rating_sum) +
                                          ")\n                                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.filteredProperties, function (group, groupId) {
                        return _c("ComparisonGroup", {
                          key: groupId,
                          attrs: {
                            "item-id": item.id,
                            group: group,
                            groupId: groupId,
                          },
                        })
                      }),
                    ],
                    2
                  )
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-comparison-group" }, [
      _c(
        "div",
        { staticClass: "c-comparison-group__item js-comparison-group-item" },
        [
          _c("span", { staticClass: "is-key" }, [
            _vm._v(
              "\n                                Hodnotenie\n                            "
            ),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }